import React, {useEffect, useState} from 'react';
import axios from "../../axios";
import Grid from '@material-ui/core/Grid'

const QuoteComponent = () => {
	const authKey = '9d9bb52a092a95341047d0fdf7f9ddd2e01eb057';

	let [quote, setQuote] = useState('You’re off to great places, today is your day. Your mountain is waiting, so get on your way.');
	let [author, setAuthor] = useState('Dr. Seuss');
	// get the quote from the service and display it


	const getQuote = () => {
		//quote URL
		const quoteURL = 'https://api.paperquotes.com/apiv1/qod/?lang=en';
		axios.get(quoteURL, {
			headers: {
				'Authorization': `Token ${authKey}`}
		}).then(
			res=> {
				const quoteData = res.data;
				setQuote(quoteData.quote);
				setAuthor(quoteData.author);
			}
		)
	}

	useEffect(() => {
		getQuote();
	});

	return (
		<Grid item xs={12}>
			<div className="quoteTitle">Thought of the Day:</div>
			<div className="quote">{quote}</div>
			<div className="author">{author}</div>
			<div className="clearFix"/>
		</Grid>
	);

}

export default QuoteComponent;
